import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-0 pb-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-4",
  "aria-live": "polite"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center py-4 text-danger",
  "aria-live": "assertive"
}
const _hoisted_5 = {
  key: 2,
  class: "text-center py-4"
}
const _hoisted_6 = {
  key: 3,
  class: "default-table-area style-two py-11 gainers-losers"
}
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle" }
const _hoisted_9 = { class: "d-flex align-items-center gap-2" }
const _hoisted_10 = ["src", "alt", "title"]
const _hoisted_11 = { class: "text-muted fs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("header", { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Gainers & Losers"),
        _createElementVNode("span", null, "Timeframe: 24h")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1)
          ]))]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args))),
                class: "btn btn-sm btn-outline-primary ms-2"
              }, " Retry ")
            ]))
          : (_ctx.displayedCoins.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No market data available "))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedCoins, (coin, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: coin.id
                        }, [
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-body fs-13", { 'border-0': index === _ctx.displayedCoins.length - 1 }])
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("img", {
                                src: coin.image,
                                alt: coin.name,
                                width: "24",
                                height: "24",
                                class: "rounded-circle",
                                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                                title: coin.name
                              }, null, 40, _hoisted_10),
                              _createElementVNode("span", null, _toDisplayString(coin.name), 1),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(coin.symbol.toUpperCase()), 1)
                            ])
                          ], 2),
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-body text-center fs-13", { 'border-0': index === _ctx.displayedCoins.length - 1 }])
                          }, " $" + _toDisplayString(_ctx.formatPrice(coin.current_price)), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-end fs-13", {
                    'text-success': coin.price_change_percentage_24h > 0,
                    'text-danger': coin.price_change_percentage_24h < 0,
                    'border-0': index === _ctx.displayedCoins.length - 1,
                  }])
                          }, _toDisplayString(_ctx.formatPercentage(coin.price_change_percentage_24h)), 3)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
    ])
  ]))
}